module.exports = __webpack_public_path__ + "static/media/再想想@2x.c90840d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/再想想@2x.png
// module id = 214
// module chunks = 0